import type { TAccessControlRules } from '@frontend/components/agromarket/core/access-control'
import {
  EAccessControlValue,
  hasUserPermissions,
  UserPermission,
  visibleForPermissionsRule,
} from '@frontend/components/agromarket/core/access-control'
import type { THarvestSaleLotsAccessControlContext } from './types'

const isCreateRequestFormShown = ({ auth }: THarvestSaleLotsAccessControlContext) =>
  !auth.isAuthenticated || hasUserPermissions([UserPermission.AGRARIAN], auth.user)

export const HARVEST_SALE_LOTS_ACCESS_CONTROL_LIST = {
  harvestSaleLotsPage: {
    dropdownFilters: {
      storeFilter: visibleForPermissionsRule([UserPermission.AGRARIAN]),
    },
    noTemplatesNotice: {
      noLotsPlaceholder: context => (!isCreateRequestFormShown(context) ? EAccessControlValue.VISIBLE : EAccessControlValue.HIDDEN),
      createRequestForm: context => (isCreateRequestFormShown(context) ? EAccessControlValue.VISIBLE : EAccessControlValue.HIDDEN),
    },
  },
} satisfies Readonly<TAccessControlRules<THarvestSaleLotsAccessControlContext>>
